import React from 'react';

import {
  work_logs_list_for_project_path,
} from '~/routes';

const WorkLogCondensedView = ({ projectId, year, month }) => {
  const [days, setDays] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!projectId || !year || !month) return;
    setLoading(true);

    jQuery.get(
      work_logs_list_for_project_path({ project_id: projectId, year, month }),
      (data) => {
        setDays((data.days || []).filter(d => d.logs.length > 0));
        setLoading(false);
      }
    );
  }, [projectId, year, month]);

  if (loading) return <div style={{ padding: '0.5rem' }}>{I18n.t('loading')}</div>;

  const formatHours = (value) => {
    const n = Number(value || 0);
    return `${Number.isInteger(n) ? n : n.toFixed(2)}h`;
  };

  const monthlyTotal = days.reduce(
    (sum, day) => sum + day.logs.reduce((s, l) => s + Number(l.time_worked || 0), 0),
    0
  );

  if (!days.length) return <div className='alert alert-info' style={{ textAlign: 'center' }}>{I18n.t('no_data')}</div>;

  return (
    <table className='table table-condensed table-striped' style={{ fontSize: '0.85em', marginBottom: 0 }}>
      <thead>
        <tr>
          <th style={{ width: '10%' }}>{I18n.t('day')}</th>
          <th style={{ width: '20%' }}>{I18n.t('user')}</th>
          <th style={{ width: '25%' }}>{I18n.t('task')}</th>
          <th style={{ width: '8%' }}>{I18n.t('hours')}</th>
          <th>{I18n.t('description')}</th>
        </tr>
      </thead>
      <tbody>
        {days.flatMap((day) =>
          day.logs.map((log, i) => (
            <tr key={`${day.date}-${i}`}>
              <td className='fw-bold'>{i === 0 ? dayjs(day.date).format('D MMM') : ''}</td>
              <td>{log.person_name}</td>
              <td>{log.task_title}</td>
              <td>{formatHours(log.time_worked)}</td>
              <td>{log.description}</td>
            </tr>
          ))
        )}
        <tr style={{ borderTop: '2px solid #dee2e6' }}>
          <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>{I18n.t('monthly_total')}</td>
          <td colSpan={2} style={{ fontWeight: 'bold' }}>{formatHours(monthlyTotal)}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default WorkLogCondensedView;
